var categoryCounts = {
  counts:{},
  load:async function(){
    if(document.querySelector("[data-dynamicCategory]")){
      this.counts = await this.getCounts();
      this.displayCounts();
      this.splitColumns();
    }
  },
  getCounts:async function(){
    return new Promise((resolve,reject)=>{
      fetch(JLAJAX.url + "count?island="+JLAJAX.region,{
        method:"GET",
        headers:{
          "Accept":"application/json"
        }
      }).then(res=>res.json())
      .then(counts=>{
          resolve(counts);
      });
    });
  },
  displayCounts:function(){
    var totalCount = 0;
    for(let category of Object.keys(this.counts)){
      totalCount += this.counts[category];
      var el = document.querySelectorAll("*[data-dynamicCategory='"+category+"']");

      for(let e of el){
        e.classList.add("show");
        var count = e.getElementsByClassName("count");
        if(count && count[0]){
          count[0].innerText = this.counts[category];

        }

      }
    }

    var el = document.querySelectorAll("*[data-categoryTotalCount]");

    for(let e of el){
      e.innerText = totalCount;

    }
  },
  splitColumns:function(){
    var el = document.querySelectorAll("[data-columns]");
    var newColumns = [];
    for(let e of el){
      var columns = e.getAttribute("data-columns");

      var items = e.querySelectorAll("li.show");
      var itemCount = items.length-1;

      var splitCount =Math.floor(itemCount/columns);

      var listElement = document.createElement("ul");
      listElement.style.width = 100/columns + "%";
      var newCount = 0;
      for(let i of items){
        if(newCount > splitCount){
          newCount = 0;
          newColumns.push(listElement);
          listElement = document.createElement("ul");
          listElement.style.width = 100/columns + "%";
        }
        listElement.append(i);
        newCount++;
      }
      newColumns.push(listElement);
      //middleItem.parentNode.insertBefore("</ul>TESTING</ul>",middleItem)

      e.innerHTML = "";
      for(let c of newColumns){

        e.append(c);
      }

    }


  }
};
